import React from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface BriefSectionProps {
  budget?: number;
  tonePreferences?: string[];
  targetCategories?: string[];
  suitabilityFilters?: string[];
}

const BriefSection: React.FC<BriefSectionProps> = ({
  budget = 10000,
  tonePreferences = [],
  targetCategories = [],
  suitabilityFilters = []
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <div className="mb-12">
      <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-6">YOUR BRIEF</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Budget */}
        <Card className="p-6">
          <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">BUDGET</h3>
          <div className="text-4xl font-bold text-foreground">
            {formatCurrency(budget)}
          </div>
        </Card>

        {/* Tone */}
        <Card className="p-6">
          <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">TONE</h3>
          <div className="flex flex-wrap gap-2">
            {tonePreferences.length > 0 ? (
              tonePreferences.map((tone, index) => (
                <Badge key={index} variant="secondary" className="text-xs">
                  {tone}
                </Badge>
              ))
            ) : (
              <span className="text-muted-foreground text-sm">No tone preferences specified</span>
            )}
          </div>
        </Card>

        {/* Content Vertical */}
        <Card className="p-6">
          <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-4">CONTENT VERTICAL</h3>
          <div className="flex flex-wrap gap-2">
            {targetCategories.length > 0 ? (
              targetCategories.map((category, index) => (
                <Badge key={index} variant="secondary" className="text-xs">
                  {category}
                </Badge>
              ))
            ) : (
              <span className="text-muted-foreground text-sm">No content verticals specified</span>
            )}
          </div>
        </Card>

      </div>
    </div>
  );
};

export default BriefSection;